import { __rest } from "tslib";
export var Item = function () {
    return null;
};
Item.getCollectionNode = function getComponetNode(props) {
    // eslint-disable-next-line camelcase
    var children = props.children, value = props.value, disabled = props.disabled, id = props.id, unsafe_props = __rest(props, ["children", "value", "disabled", "id"]);
    return {
        id: id,
        disabled: disabled,
        value: value,
        content: children,
        unsafe_props: unsafe_props,
    };
};
